import React from 'react';
import Hls from "hls.js";
import {cl,globs,ocf,getTime,az}
from '../../components/utils/utils';
import {wsTrans} from '../utils/utils'

class C18SystemAtlas00 extends React.Component{
  constructor(props) {
    super(props);
    this.state={
      systemAtlas:{},
      paused:true,
    }
    this.hi={ // HLS Info
      xc:[],
      hlsSlots:[null,null],
      vids:[null,null],
      topSlot:0,// *currently* playing - use other next
      xcPos:0,// position in *paragraphs*, not time
      fade:1.0,
      topOpac:0,
    }
    this.loadInfo()
    this.setBreadCrumbs()
//     this.mainDiv=React.createRef();
    this.videoRefB=React.createRef();
    this.videoRefF=React.createRef();
    this.tlRef=React.createRef();
    this.tlTextRef=React.createRef();
//     this.videos=[
//     {title:}
//     ]
  }

  getVideoList=async()=>{
    let resp=await wsTrans("usa", {cmd: "cRest", uri: "/s/systemAtlas",
      method: "retrieve",sessionId: globs.userData.session.sessionId,
      body: {}})
    let videos={}
    cl(resp.data)
    resp.data.forEach(d=>{
      cl(d)
//       let extPos=d.video.lastIndexOf(".")
//       d.video=d.video.substring(0,extPos)+".mp4"
//       let para=d.Gene_para||d.Presenter_para
//       let xc=d.Gene||d.Presenter
//       para.forEach((p,i)=>{
// //         cl(p)
// //         cl(xc)
//         p.ts=xc[p.line].start
//         p.idx=i
//       })
      videos[d.id]=d
    })
    cl(videos)
    this.setState({systemAtlas:videos})
  }

  loadXc=()=>{
    this.hi.xc=this.testData
    let pos=0
    this.hi.xc.forEach(x=>{
      x.pos=pos
      pos+=x.end-x.start
    })
    this.hi.xcPos=0
//     cl(this.hi.xc)
  }

  loadTranscripts=async()=>{
    let resp=await wsTrans("usa", {cmd: "cRest", uri: "/s/systemAtlas",
      method: "retrieve",sessionId: globs.userData.session.sessionId,
      body: {}})
  }

  loadInfo=async()=>{
//     let res=await fetch(
//       "/media/systemAtlas/2025-09-14_08-16-43_para.json")
//     let xs=await res.json()
// //     cl(xs)
//     this.setState({xs:xs})
//     this.vttSrc="https://l4-media.s3.amazonaws.com/media/video/systemInfo/2025-09-15_09-01-37.mp4/master.m3u8"
    this.vttSrc="2025-09-15_09-01-37"
    this.vttLang="en"
    this.vttLabel="English"
    this.loadXc()
    await this.getVideoList()
//     this.xs=await res.json()
//     cl(this.xs)
  }

  setBreadCrumbs=()=>{
//     cl(this.props)
    if(this.props.parms){
//       cl("onChange")
      this.props.parms.onChange(
        {
          cmd: "breadcrumbs",
          data:
            {breadcrumbs: [
              {t:"Sites", url:"/usa/c18/sites"},
              {t:"Admin", url:`/usa/c18/admin`},
              {t:"System Atlas", url:`/usa/c18/systemAtlas`},
            ]},
        },
      )
    }
  }

  componentDidMount() {
//     this.attachPlayer(this.videoRefF);
  }

//   componentDidUpdate(prevProps) {
//     if (prevProps.src !== this.props.src) {
//       this.detachPlayer();
//       this.attachPlayer();
//     }
//   }

  componentWillUnmount() {
    this.detachPlayer();
  }

//   onError=(msg)=>{
//     cl(msg)
//   }

  once=(target, event)=>{
    return new Promise((resolve) => {
      const handler = (...args) => {
        if (target.off) target.off(event, handler);
        else target.removeEventListener(event, handler);
        resolve(args);
      };
      if (target.on) target.on(event, handler);
      else target.addEventListener(event, handler, { once: true });
    });
  }

  loadPausedAndSeek=async(/*video,*/ vid, t = 0/*, existingHls = null*/)=>{
// t is the time in the clip, not the xc
  // assume that this.topSlot points to the *current*, use *other*
// only load new video *if* it's different, *and* update topSlot - no!
// returns the slot that it was loaded to
//     cl(`LoadPause ${vid} at ${t}`)
    var video
//     cl(this.hi.topSlot)
//     cl(this.hi.vids[this.hi.topSlot])
    let newSlot=this.hi.topSlot?0:1// *other* slot
    cl(`loadPaused: slot: ${newSlot}, vid: ${this.hi.vids[newSlot]}, t:${t}`)
    if(vid==this.hi.vids[newSlot]){// seek in *same* video
//       cl("seek in same")
      video=(newSlot)?this.videoRefF.current:this.videoRefB.current
//       cl(newSlot,t)
      video.currentTime=t
      return {loadSlot:newSlot}
    }
    let url=
      `https://l4-media.s3.amazonaws.com/media/video/systemInfo/${vid}.mp4/master.m3u8`
    video=((newSlot)?this.videoRefF:this.videoRefB).current
    this.vidPause(video)
//     video.pause();
    let oldHls=this.hi.hlsSlots[newSlot]
//     cl(oldHls)

    // If an Hls.js instance is managing this element, tear it down
    if (oldHls/*?.media === video*/) {
      try {
        oldHls.stopLoad();
        oldHls.detachMedia();
        oldHls.destroy();
      } catch {}
    }

    // Native HLS path (Safari/iOS)
    if (video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = url;
      video.load(); // initializes without playing
      await this.once(video, 'loadedmetadata'); // duration/track info ready
      video.currentTime = Math.max(0, t);
      // stay paused; caller can call video.play() later
      return null; // no hls instance
    }


    // hls.js path
    const hls = new Hls({ enableWorker: true });
    hls.attachMedia(video);

    await this.once(hls, Hls.Events.MEDIA_ATTACHED);
    hls.loadSource(url);

    // When manifest is parsed, we can safely seek while paused
    await this.once(hls, Hls.Events.MANIFEST_PARSED);

    // Option A (simple): set currentTime; hls.js will fetch the right fragments
    cl(`video curTime: ${t}, slot: ${newSlot}`)

    video.currentTime = t//Math.max(0, t);

    // Option B (alternative): prime buffering from t explicitly
    // hls.startLoad(t);
    this.hi.vids[newSlot]=vid
    this.hi.hlsSlots[newSlot]=hls// this is the *new* slot
//     video.ontimeupdate=this.showTime// set timer callback
    cl("loadPaused done")
//     cl(this.state.curPos)
    return {loadSlot:newSlot}
//     this.hi.topSlot=newSlot
  //   return hls;
  }

//   attachPlayer(vRef,src) {
//     const video = vRef.current;
// //     cl(video)
// //     var { src, onError } = this.props;
//
// //     src = "https://l4-media.s3.amazonaws.com/media/video/systemInfo/test0/master.m3u8";
// //     src=this.vttSrc
//     if (!video || !src) return;
//     cl("still here")
//
//     // Safari / iOS supports native HLS
//     if (video.canPlayType("application/vnd.apple.mpegurl")) {
//       video.src = src;
//       cl("can play")
//       return;
//     }
//
//     // Other browsers → use hls.js
//     if (Hls.isSupported()) {
//       this.hls = new Hls({ enableWorker: true });
//
//       this.hls.on(Hls.Events.ERROR, (_, data) => {
//         if (data.fatal) {
//           if (data.type === Hls.ErrorTypes.NETWORK_ERROR) {
//             this.hls.startLoad();
//           } else if (data.type === Hls.ErrorTypes.MEDIA_ERROR) {
//             this.hls.recoverMediaError();
//           } else {
//             this.hls.destroy();
//           }
//         }
//         this.onError(data);
//       });
//
//       this.hls.loadSource(src);
//       this.hls.attachMedia(vRef.current);
//     }
//   }

  detachPlayer() {
    this.hi.hlsSlots.forEach(h=>{
      if(h){h.destroy()}
    })
//     if (this.hls) {
//       this.hls.destroy();
//       this.hls = null;
//     }
  }

//   getTranscript=async()=>{
// //     let res=await fetch(
// //       "/home/gknight/Videos/obs/2025-09-14_08-16-43_para.json")
// //     cl(res)
//   }

//   openPlayer2 = (videoName) => {
//     cl(videoName)
//     const src = `https://l4-media.s3.amazonaws.com/media/video/systemInfo/\
// ${videoName}/master.m3u8`;
//     const w = window.open(`/atlasPlayer.html?src=${src}`,
// //     const w = window.open(`/player.html?src=${encodeURIComponent(src)}`,
//       "SystemAtlasPlayer",
//       );
// //       "popup,width=1280,height=760");
//     this.playerWin = w;
//   };

//   openPlayer = () => {
//     const src = "https://l4-media.s3.amazonaws.com/media/video/systemInfo/test0/master.m3u8";
//     this.playerWin = window.open(`/atlasPlayer.html?src=${src}`,
//       "SystemAtlasPlayer",
//       );
// //       "popup,width=1280,height=760");
// //     this.playerWin = w;
//   };

//   send = (msg) => {
//     if (this.playerWin && !this.playerWin.closed) {
//       this.playerWin.postMessage(msg, "*"); // optionally restrict to your origin
//     }
//   };

  // Call this on transcript click
//   seekTo = (seconds) => this.send({ cmd: "seek", t: seconds });  ocf=(func,val)=>{return e=>{func(val,e)}}

//   setPos=(obj)=>{
//     cl(obj)
//     const v = this.videoRef.current;
//     cl(v)
//     if (!v) return;
//     const go = () => { v.currentTime = obj.pos; v.play(); };
//     (v.readyState >= 1) ?
//     go() :
//     v.addEventListener("loadedmetadata", go, { once: true });
//   }

//   seekTo = (seconds) => {
//     const v = this.videoRef.current;
//     if (!v) return;
//     const go = () => { v.currentTime = seconds; v.play(); };
//     (v.readyState >= 1) ?
//       go() :
//       v.addEventListener("loadedmetadata", go, { once: true });
//   };

//   showTranscript=()=>{
//     let st=this.state
// //     cl(st.xs)
// //     let xs=await getTranscript
//     let paras=(st.xs||[]).map((x,i)=>{
//       return(
//         <React.Fragment key={i}>
//         <span style={{color:"#004488",cursor:"pointer"}}
//           onClick={this.ocf(this.setPos,{pos:x.start})}
//           >{x.title}
//         </span>
//           <p>{x.text}</p>
//         </React.Fragment>
//       )
//     })
//     return paras
// //     return(
// //       <div style={{width:"100%",height:450,border:"1px solid black"}}>
// //       </div>
// //     )
//   }

//   getNextVideo=()=>{
//     let curVid=this.hi.xc[this.hi.xcPos].vid
//     for(let i=this.hi.xcPos+1;i<this.hi.xc.length;i++){
//       if(this.hi.xc[i].vid!=curVid){return i}
//     }
//     return 0// invalid "next" index
//   }

  getCurVid=()=>{
    return (this.hi.topSlot)?
      {ref:this.videoRefF.current,vid:this.hi.vids[1]}:
      {ref:this.videoRefB.current,vid:this.hi.vids[0]}
  }

  clipTimeToXcTime=(clipTime)=>{
//     cl(clipTime)
// find the para that we're in, and convert to xcTime
    let st=this.state
    let curVid=this.getCurVid().vid
//     cl(curVid,clipTime)
    let paras=st.systemAtlas[st.selVideo].paras
    for(let i=0;i<paras.length;i++){
      let para=paras[i]
//       cl(`pos: ${para.pos}, start: ${para.start}, end: ${para.end}`)
      if(((para.vid==curVid)&&(para.start<=clipTime))&&(para.end>clipTime)){
//         cl(para)
        let xcTime=clipTime-para.start+para.pos
//         cl(`para ${i}, clip: ${clipTime}, xc: ${xcTime}`)
        return xcTime
      }
    }
    return clipTime
  }

  showTime=(x)=>{
//     if(this.state.paused){return}
//     cl(Math.round(x.timeStamp/10)/100)
//     cl(this.videoRefF.current)
//     console.trace()
//     cl(this.videoRefB.current)
//     cl(this.state.curPos)
//     cl(x.target.currentTime)
//     cl(x.target)

    let xcTime=this.clipTimeToXcTime(x.target.currentTime)
    this.updTransTO(this.hi.nextTrans-xcTime)
//     clearTimeout(this.hi.transTo)
//     this.hi.transTo=setTimeout(this.doTrans,(this.hi.nextTrans-xcTime)*1000)
//     cl(xcTime)
    this.setState({curPos:xcTime})
//     cl(x.target.currentTime,this.hi.topSlot,xcTime)

//     let vid=(this.hi.topSlot)?this.videoRefF.current:this.videoRefB.current
//     cl(vid.currentTime)
  }

//   fadeVideo=()=>{
// /*We're playing a video, and have to switch to the other one:
// start the other video, muted,start the fade, */
//   }

//   doFade=()=>{
// /* hi.startFadeTime,stopFadeTime is the time range, startOpac,stopOpac is the
// actually, if topSlot is true (playing top), then 1->0, else 0->1
// hi.fade is the total time
// this assumes that topSlot is not going to change until the *end* of the fade*/
//     let now=getTime()
//     let hi=this.hi
//     let curFrac=(now-hi.startFade)/hi.fade
//     curFrac=Math.min(1,Math.max(0,curFrac))// assure 0-1
//     let curOpac=(hi.topSlot)?1-curFrac:curFrac
//   }

//   playVideo=async()=>{// play button pressed
// // there are three videos here: curVid - the vid we're playing from, xcVid - the vid we're showing
// // and diffVid - the next new video to load
// /* this function finds the next video, finds the place to start i it, loads the video
// and sets the timer to go off when it should start*/
//     cl("play")
//     let curVidRef=(this.hi.topSlot?this.videoRefF:this.videoRefB).current
// //     curVidRef.ontimeupdate=this.showTime
// //     curVidRef.currentTime=0
// //     curVidRef.play()
//     let diff=this.getNextVideo()// next *different* para index
// //     cl(diff)
//     if(diff){
//       let curPara=this.hi.xc[this.hi.xcPos]// the para we're in
//       let diffPara=this.hi.xc[diff]// the first para of the diffVid
// //       let url=
// //         `https://l4-media.s3.amazonaws.com/media/video/systemInfo/${diffPara.vid}.mp4/master.m3u8`
//       let diffPos=diffPara.start-this.hi.fade/2// where to start in the new video
//       if(diffPos<0){diffPos=0}
//       await this.loadPausedAndSeek(diffPara.vid,diffPos)// load the diff vid into other slot
//       let vidPos=curVidRef.currentTime
//       let diffStart=diffPara.pos-this.hi.fade/2// where to start the diff vid
//       let curPos=vidPos-curPara.start+curPara.pos// this is where we are in xcVid
// // we want where we are in the video - where the para started + the pos of the para
//       cl(curPos, vidPos, curPara.start, curPara.pos)
//     }
//   }

// this.videoRef.current.ontimeupdate = () => {
//   console.log(this.videoRef.current.currentTime);
// };
// // Play
// video.play();
//
// // Pause
// video.pause();


//   startVideoTest=async()=>{
//     cl("start video")
//     await this.loadPausedAndSeek(this.vttSrc,10)
//     this.hi.topSlot=(this.hi.topSlot?0:1)
// //     let nextPara=this.hi.xc[1]
// //     cl(nextPara)
// //       let url=
// //         `https://l4-media.s3.amazonaws.com/media/video/systemInfo/${nextPara.vid}.mp4/master.m3u8`
// //     this.loadPausedAndSeek(url,10)
//   }

  doDissolve=()=>{
//     cl(getTime(),this.hi)
    let frac=(getTime()-this.hi.dissolveStart)
    if(frac>1){
      clearInterval(this.hi.dissolveInt)
      frac=1
    }
    if(this.hi.dissolveSlot){frac=1-frac}
//     cl(frac,getTime())
// cl(frac)
    this.videoRefF.current.style.opacity=frac
  }

  dissolve=()=>{
    this.hi.opacStart=0
    this.hi.dissolveSlot=this.hi.topSlot
    this.hi.dissolveStart=getTime()
    this.hi.dissolveInt=setInterval(this.doDissolve,10)
  }

  doTrans=()=>{
    cl("doTrans")
    this.dissolve()
    setTimeout(x=>{
      let oldVid=(this.hi.topSlot)?this.videoRefF.current:this.videoRefB.current
      let newVid=(this.hi.topSlot)?this.videoRefB.current:this.videoRefF.current
      this.vidPause(oldVid)
      this.vidPlay(newVid)
      this.hi.topSlot=(this.hi.topSlot?0:1)
    },500)
//     oldVid.pause()
//     newVid.play()
//     newVid.ontimeupdate=this.showTime
    setTimeout(this.setTransTO,1000)
//     this.setTransTO()
  }

  loadNextVideo=async(selVideo,ind)=>{
// assumes that topSlot is *current* vid
// ind is *after* current para
// find and load next video change
    cl(`loadNext vid:${selVideo}, ind: ${ind}`)
    let st=this.state
    let paras=st.systemAtlas[selVideo].paras
    let vid0=paras[ind].vid
    for(let i=ind+1;i<paras.length;i++){
      if(paras[i].vid!=vid0){
//         let dur=paras[i].pos-xcTime
        cl(`new vid at ${i}, ${paras[i].vid}`)
//         this.hi.transTo=setTimeout(this.doTrans,dur*1000)
        await this.loadPausedAndSeek(paras[i].vid,paras[i].start)
        return paras[i].pos// start of next vid
      }
    }
  }

  updTransTO=(dur)=>{
//     dur-=0.5
    if(dur<0){return}
    cl(`clear TO: ${this.hi.transTo}`)
    clearTimeout(this.hi.transTo)
    this.hi.transTo=setTimeout(this.doTrans,dur*1000)
    cl(`create TO: ${this.hi.transTo} of ${dur}`)
  }

  setTransTO=async()=>{
    cl("set transTo")
    let st=this.state
    let curVid=this.getCurVid()
    let clipTime=curVid.ref.currentTime
    let xcTime=this.clipTimeToXcTime(clipTime)
//     cl(curVid.vid,clipTime,xcTime)
//     cl(`clipTime: ${clipTime}, xcTime: ${xcTime}`)
    let ind=this.findParagraph(xcTime)// returns *next*
//     let vid0=paras[ind].vid
    let pos=await this.loadNextVideo(st.selVideo,ind)
    this.hi.nextTrans=pos
    if(pos&&!st.paused){
      let dur=pos-xcTime
      cl(pos,xcTime)
      this.updTransTO(dur)
//       clearTimeout(this.hi.transTo)
//       this.hi.transTo=setTimeout(this.doTrans,dur*1000)
    }
//     cl(vid0,xcTime)
//     let paras=st.systemAtlas[st.selVideo].paras
//     for(let i=ind+1;i<paras.length;i++){
//       if(paras[i].vid!=vid0){
//         let dur=paras[i].pos-xcTime
//         cl(`new vid at ${i}, ${paras[i].vid}, in ${dur} secs`)
//         this.hi.transTo=setTimeout(this.doTrans,dur*1000)
//         await this.loadPausedAndSeek(paras[i].vid,paras[i].start)
//         return
//       }
//     }
//     cl(vid0)

  }

  vidPlay=(vid)=>{
    vid.play()
    vid.ontimeupdate=this.showTime
  }

  vidPause=(vid)=>{
    vid.pause()
    vid.ontimeupdate=null
  }

  playPause=e=>{
//     cl(e)
    cl("playPause")
    e.stopPropagation()
//     cl(this.hi.topSlot, this.videoRefB.current.currentTime,this.state.curPos)
    let vid=(this.hi.topSlot)?this.videoRefF.current:this.videoRefB.current
//     cl(vid.currentTime)
    let paused=vid.paused
    if(paused){
      this.vidPlay(vid)
//       vid.play()
//       vid.ontimeupdate=this.showTime
      this.setTransTO()
    }else{
      cl(`clear TO: ${this.hi.transTo}`)
      clearTimeout(this.hi.transTo)
      this.vidPause(vid)
//       vid.pause()
    }
    this.setState({paused:!paused})
  }

//   findPara=(pos)=>{
//     let st=this.state
// //     let xc=
//   }

//   indexToPos=(pos)=>{
//     let paraInd=this.findPara(pos)
//   }



  setPos=async e=>{
    cl("setPos")
    let st=this.state
    if(!st.selVideo){return}
    let curVid=this.getCurVid()
    this.vidPause(curVid.ref)
    let rect=e.currentTarget.getBoundingClientRect()
    let relPos=(e.clientX-rect.x)/rect.width
//     cl(relPos)
    let vidPos=relPos*this.hi.totLen
    cl(vidPos)
//     this.hi.curPos=vidPos
    let ind=this.findParagraph(vidPos)
    let para=st.systemAtlas[st.selVideo].paras[ind]
    cl(para)
    let clipTime=vidPos-para.pos+para.start
//     let vid=para.vid
    this.hi.topSlot=(this.hi.topSlot)?0:1
    let res=await this.loadPausedAndSeek(para.vid,clipTime)
    this.hi.topSlot=res.loadSlot
    await this.loadNextVideo(st.selVideo,ind)

//     cl(this.hi.topSlot)
    let video=((this.hi.topSlot)?this.videoRefF:this.videoRefB).current
//     this.hi.topSlot=(this.hi.topSlot)?0:1
    this.vidPause(video)
//     video.pause()
//     cl(para)
    this.setState({curPos:vidPos,paused:true})
//     cl(e)
//     cl(e.clientX,e.clientY)
//     cl(e.target)
//     let rect=e.target.getBoundingClientRect()
//     cl(rect)
// //     let wid=
//     cl((e.clientX-rect.x)/rect.width)
  }

  findParagraph=(secs)=>{// secs in xcTime
    let st=this.state
    var i
    let paras=st.systemAtlas[st.selVideo].paras
    for(i=0;i<paras.length;i++){
      if(paras[i].pos>secs){break}
    }
    return i-1
  }

  getParaRange=(secs)=>{
    let st=this.state
    let el=this.tlTextRef.current
//     cl(st.selVideo)
    if(!st.selVideo){return}
    const computedLineHeight = parseFloat(getComputedStyle(el).lineHeight);
//     cl(el)
//     cl(getComputedStyle(el).lineHeight)
//     cl(el.scrollHeight)
//     cl(el.clientHeight)
//     cl(st.xcLines?.length)
//     cl((el.scrollHeight)/st.xcLines?.length)
    let lineHeight=el.scrollHeight/st.xcLines?.length
//     cl(st.systemAtlas,st.selVideo)
    let paras=st.systemAtlas[st.selVideo].paras
//     cl(paras)
//     cl(paras.length)
//     var i
    let i=this.findParagraph(secs)
//     for(i=0;i<paras.length;i++){
//       if(paras[i].pos>secs){break}
//     }
    let begLine=paras[i]?.linePos||0
    let endLine=paras[i+1]?.linePos
    let begTime=paras[i]?.pos||0
    let endTime=paras[i+1]?.pos
    if(i>=paras.length){
      endLine=this.hi.totLines
      endTime=this.hi.totLen
    }
//     cl(endLine,begLine,secs,endTime,begTime)
    let scrollHeight=lineHeight*(endLine-begLine)*secs/(endTime-begTime)
//     cl(scrollHeight,i)
    this.tlTextRef.current.scrollTop=scrollHeight
  }

  tlMouseMove=(e)=>{
    let st=this.state
    if(!st.systemAtlas[st.selVideo]){return}
    let rect=e.currentTarget.getBoundingClientRect()
    let frac=(e.clientX-rect.x)/rect.width
    let vidPos=frac*this.hi.totLen// position in seconds
//     cl(vidPos)
    let tlHover=Math.min(610-200,Math.max(0,frac*610-100))
    this.getParaRange(vidPos)
//     this.tlTextRef.current.scrollTop=12978

//     let this.
    if(!st.inTl){

    }
    this.setState({inTl:true,vidHoverPos:vidPos,tlHover:tlHover})
//     cl(e)
  }

  tlMouseOut=(e)=>{
//     cl("mouse out")
    this.setState({inTl:false})
//     cl(this.state.xcLines)
  }

  showTimeline=()=>{
    let st=this.state
//     cl(st.curPos)
    let curTime=this.makeMinSec(st.curPos||0)
    let totTime=this.makeMinSec(this.hi.totLen)
    let hovTime=this.makeMinSec(st.vidHoverPos)
    let curPos=(st.curPos||0)/(this.hi.totLen||1)*610
//     cl(curPos)
    let textBox=(st.inTl)?"block":"none"
    let vid=(this.hi.topSlot)?this.videoRefF.current:this.videoRefB.current
//     let playPause=vid.paused?"play":"pause"
//     cl(vid.paused)
//     let boxPos=
//               src={`/images/media/pause.png`}
    return(
      <div>
        <div style={{width:"fit-content",padding:5,backgroundColor:"#CCCCCC",marginTop:-3,
        }}
        >
            <img
              src={`/images/media/${st.paused?"play":"pause"}.png`}
              width="20" style={{display:"inline-block",cursor:"pointer",
//               margin:"-15px 0px -10px 0px"

            }} onClick={this.playPause}/>
          <div ref={this.tlRef}
            style={{width:610,height:20,border:"1px solid black",display:"inline-block",
            marginBottom:0,position:"relative"
          }}
            onClick={this.setPos}
            onMouseMove={this.tlMouseMove}
            onMouseOut={this.tlMouseOut}
          >
            <div style={{width:610,height:18,backgroundColor:"#666666"}}>
              <div ref={this.tlTextRef}
                style={{position:"absolute",top:20,left:st.tlHover,width:200,height:200,
                backgroundColor:"white",display:textBox,border:"1px solid black",padding:5,overflowY:"hidden"}}>
                {st.xcLines}
              </div>
            </div>
            <div style={{width:curPos,height:18,backgroundColor:"#44CC44",position:"absolute",
              top:0,left:0,
            }}>
            </div>
            <div style={{width:610,height:18,
              position:"absolute",top:0,left:0}}>
              <span style={{color:"white",float:"left",cursor:"default"}}>&nbsp;{curTime}</span>
              <span style={{color:"white",float:"right",cursor:"default"}}>{totTime}&nbsp;</span>
            </div>
            <div style={{width:70,height:18,backgroundColor:"white",position:"absolute",
              top:0,left:(st.tlHover||0),textAlign:"center",cursor:"default",
            display:textBox,
            }}>{hovTime}
            </div>
          </div>
        </div>
      </div>
    )
  }



  showVideo0=(src)=>{// on same tab
//     cl(src)
    return(
      <div style={{padding:0}}>
        <h3>Select Video</h3>
        <div style={{width:"fit-content",border:"1px solid black",borderRadius:10,
          padding:10,maxHeight:80,overflowY:"auto"}}>
        {this.showVideoList()}
        </div><br/>
        <div style={{position:"relative"}}>
          <div style={{position:"relative"}}>
            <video id="vidBack"
              ref={this.videoRefB}
              crossOrigin="anonymous"
              controls={this.controls/*||true*/}
              autoPlay={false&&this.autoPlay}
              muted={this.muted||false}
              poster={this.poster}
              playsInline
              style={{ width: 640, maxWidth: 1200, background: "#000" }}
            >
              {/* Native HLS (Safari) will use the <source>; other browsers ignore it */}
              <source src={src} type="application/vnd.apple.mpegurl" />
              {src && (
                <track
                  src={src}
                  kind="subtitles"
                  srcLang={this.vttLang}
                  label={this.vttLabel}
                  default
                />
              )}
            </video>
          </div>
          <video id="vidFront"
            ref={this.videoRefF}
            crossOrigin="anonymous"
            controls={this.controls/*||true*/}
            autoPlay={false&&this.autoPlay}
            muted={this.muted||false}
            poster={this.poster}
            playsInline
            style={{ width: 640, maxWidth: 1200, background: "#000" }}
          >
            {/* Native HLS (Safari) will use the <source>; other browsers ignore it */}
            <source src={src} type="application/vnd.apple.mpegurl" />
            {src && (
              <track
                src={src}
                kind="subtitles"
                srcLang={this.vttLang}
                label={this.vttLabel}
                default
              />
            )}
          </video>
          {this.showTimeline()}
        </div>
      </div>

    )
  }
//         <br/><button type="button" onClick={this.startVideoTest}>Start</button>
//         <br/><button type="button" onClick={this.playVideo}>Play</button>

//   showVideo=()=>{
//     const src = "https://l4-media.s3.amazonaws.com/media/video/systemInfo/test0/master.m3u8";
// //     cl(this.vttSrc)
//     return(
//       <div>
//         <div>
//         <button onClick={this.openPlayer}>Open Player</button>
//           <div>
//             {/* Example transcript row */}
//             <button onClick={() => this.seekTo(42)}>Jump to 00:42</button>
//             <button onClick={() => this.send({ cmd: "play" })}>Play</button>
//             <button onClick={() => this.send({ cmd: "pause" })}>Pause</button>
//             <button onClick={() => this.send({ cmd: "fullscreen" })}>Fullscreen</button>
//           </div>
//         </div>
//       </div>
//     )
//   }

  makeVidToXc=(id)=>{
    let st=this.state
    let maxLen=26
    let paras=st.systemAtlas[id].paras
    cl(paras)
//     let starts=[]
    let pos=0
    let lines=[]
    paras.forEach((p,i)=>{
//       starts.push(pos)
      p.pos=pos
      p.linePos=lines.length
      pos+=(p.end-p.start)
      let text=p.text
      let j=0
      while((j++<100)&&text.length){
        let line0=text.substring(0,maxLen)
        let lastSp=(text.length<=maxLen)?text.length:line0.lastIndexOf(" ")
//         let lastSp=
//         cl(lastSp,line0)
        let line
        lines.push(line0.substring(0,lastSp))
        text=text.substring(lastSp+1)
//         cl(text.length)
//         cl(lastSp,text.substring(0,maxLen))
      }
    })
//     cl(lines)
//     cl(paras)
//     this.hi.curPos=0
    this.setState({curPos:0})
    this.hi.totLen=pos
    this.hi.totLines=lines.length
    cl("makeVidToXc done")
    return lines=lines.map((l,i)=>{return (<span key={i}>{l}<br/></span>)})
  }

  makeMinSec=(secs)=>{
//     cl(secs)
    secs=Math.round(secs||0)
    return `${Math.floor(secs/3600)}:${az(Math.floor(secs/60),2)}:${az(secs%60,2)}`
  }

//   loadVideos=async(val)=>{
// // a video has been selected. load the first *and* next, starting at 0
//     let st=this.state
//     let vid1=st.systemAtlas[val].paras[0].vid// first video to show
//     this.hi.topSlot=1// start playing on back
//     this.loadPausedAndSeek(vid1,0)// load to other
//     this.hi.topSlot=0// start playing on back
//     await this.loadNextVideo(0)
//   }

  selVideo=async(e,val)=>{
    let st=this.state
    cl(val)
    cl(st.systemAtlas[val])
    let vid1=st.systemAtlas[val].paras[0].vid// first video to show
    this.hi.topSlot=1// start playing on back
    await this.loadPausedAndSeek(vid1,0)// load to other
    this.hi.topSlot=0// start playing on back
    await this.loadNextVideo(val,0)



//     await this.loadVideos(val)
//     let vid1=st.systemAtlas[val].paras[0].vid// first video to show
//     this.hi.topSlot=1// fake it out to use 0
    let xcLines=this.makeVidToXc(val)
// //     await this.loadPausedAndSeek(vid1,10)
//     this.hi.topSlot=0
    this.setState({selVideo:val,xcLines:xcLines})

  }

  showVideoList=()=>{
    let st=this.state
//     cl(st.systemAtlas)
//     let videos=(st.systemAtlas||[]).map(sa=>{return sa.video})
    let rows=(Object.keys(st.systemAtlas||{})).map((k,i)=>{
      let v=st.systemAtlas[k]
      let bg=(v.id==st.selVideo)?"#88CCFF":null
      return(
      <span key={i} style={{cursor:"pointer",fontWeight:700,
        color:"#004488",backgroundColor:bg}}
      onClick={ocf(this.selVideo,v.id)}
      >{v.title}<br/></span>
    )})
//     cl(videos)
    return rows

  }

//   makeParagraph=(para)=>{
//     let st=this.state
//     let idx=para.idx
//     let vid=st.systemAtlas[st.selVideo]
//     let startLine=vid.Gene_para[idx].line
//     cl(idx,vid.Gene_para.length)
//     cl(vid.Gene_para[idx+1]?.line)
//     let endLine=(idx>=vid.Gene_para.length)?
//       vid.Gene_para.length:
//       vid.Gene_para[idx+1]?.line
//     let paraText=""
//     for(let i=startLine;i<endLine;i++){
//       paraText+=vid.Gene[i].text
//     }
// //     cl(startLine,endLine)
// //     cl(vid)
// //     cl(paraText)
//     this.setState({xcParaText:paraText})
//   }

//   selXc=(e,val)=>{
//     cl(val)
//     this.makeParagraph(val)
// //     this.setPos({pos:val.ts})
//     this.send({ cmd: "seek", t: val.ts })
//     this.setState({selXc:val})
//   }

//   showTranscript2=()=>{
//     let st=this.state
// //     cl(st)
//     let xc=(st.systemAtlas||{})[st.selVideo]||{}
// //     cl(xc)
//     let rows=(xc.Gene_para||[]).map((p,i)=>{
// //       cl(p)
//       var bg,paraText
//       if(p.idx==st.selXc?.idx){
//         bg="#88CCFF"
//         paraText=st.xcParaText
//       }
//       return(
//         <div key={i}>
//         <span style={{fontSize:18,fontWeight:700,color:"#004488",
//           cursor:"pointer",backgroundColor:bg}}
//           onClick={ocf(this.selXc,p)}
//         >{p.Subject}<br/></span>
//         {paraText&&
//           <p>{paraText}</p>
//         }
//         </div>
//       )
//     })
//     return(
//       <div>{rows}</div>
//     )
//   }

//   showPlayPause=()=>{
//     return(
//       <button style={{border:"1px solid #AAAAAA"}}>
//       <img src="/images/media/play.png" width="18"
//       style={{marginTop:3}}/>
//       </button>
//     )
//   }

  render(){
//     cl("render")
//     cl(this.state.curPos)

    return(
      <div ref={this.mainDiv} style={{width:"100%",height:1000,backgroundColor:"white", padding:10,
        border:"1px solid black", /*float:"left",*/
      }}>
      {this.showVideo0(this.vttSrc)}
      </div>
    )
//       <video id="video" controls playsinline crossorigin="anonymous"></video>

//     return(
//       <div ref={this.mainDiv} style={{width:"100%",height:1000,backgroundColor:"white", padding:10,
//         border:"1px solid black", /*float:"left",*/
//       }}>
//       <h3>Videos</h3>
//       {this.showPlayPause()}
//       <div style={{width:600}}>
//       Note that the video will appear in a new tab. Move that tab to somewhere you can see both it and this control area, and you'll be able to navigate, and view, the videos.
//       </div><br/>
//       <div style={{width:600,height:200,border:"1px solid #AAAAAA",
//         borderRadius:10,padding:10,}}>
//         {this.showVideoList()}
//       </div>
//       <h3>Transcript</h3>
//       <div style={{width:600,height:500,border:"1px solid #AAAAAA",
//         borderRadius:10,padding:10,overflowY:"auto"}}>
//         {this.showTranscript2()}
//       </div>
//       <div style={{width:"80%",border:"1 px solid black",
//         height:450,float:"left",
//       }}>
//       {this.showVideo()}
//       </div>
//       </div>
//     )
//       <div style={{width:"20%",border:"1 px solid black",
//         height:450,float:"left",overflowY:"auto"
//       }}>
//       {this.showTranscript()}
//       </div>
//     return React.createElement("input",this.props)
  }
  testData=[{"subject":"Introduction to Server Overview","text":" Okay, so this is everything that we have in the world. This is all of the instances that we have running, a number of which we'll deal with very shortly because they are not critical parts of the system. And I'm sorry, at the beginning of these discussions, today and tomorrow certainly, and quite possibly well past then, this information is going to come fairly randomly because, like I said, we are starting with everything that exists. So give it a few days and the important things will start to gel together, but at the beginning this is truly like drinking out of a fire hose. So with that said, up","start":0,"end":53.76,"vid":"2025-09-15_09-01-37"},
{"subject":"Introduction to Linux screen tool","text":" So Siddhav, are you familiar with screen on Linux? Because this is screen running here. Screen is a fantastic tool in that it allows, first of all, you'd have multiple tabs. This is all, let me go to another server, this is stage green. And so on stage green, I can have these five tabs. These are accessible through the function keys. So I just pressed F1, that takes us back to the first window.","start":96.36,"end":132.2,"vid":"2025-09-17_09-03-33"},
{"subject":"Overview of LB1 in Old Cloud System","text":" here, LB1. LB1 is a part of our old cloud system. The old cloud system has a front-end that runs on PHP using Joomla, which is similar to WordPress. The work was done, I don't know, probably 10 or 15 years ago for the bulk of it. I took it over seven years ago and we made many updates at that time. Brian has made a few updates to it since then. So the front-end runs on Joomla. The back-end is implemented on the server in PHP and all of our old controllers communicate with the server every 15 seconds for each controller. And at that time it says, what do you want me to do next? And then the server comes back and it says, I want you to send me your current sensor data. It does that every 30 seconds. It can ask the controller to send up all of its configuration. It can also tell the controller to download full configuration. It's not broken up the way our current cloud is. Our current cloud deals with parameters rather than all of configuration. The old club, with the old cloud, it's all or nothing at all. To handle the 3,000 some controllers that are talking to the cloud at any given moment, we have two task servers. Those are actually these guys down here. Main task 2x, main task 1x. 2x is because it is actually physically twice the capacity of 1x. So we have essentially three units of processing power here with main task 2x handling twice load. You can see that over here with the instance type. 2x is a 2x large whereas 1x is just an x large. Now to handle the load balancing on that, I don't know if AWS was not so advanced at that time. I really don't know the history on that. But in any case, all of the load balancing was handled by the by LB1. So LB1, it's a medium. It probably could be a small if not even a nano because all it does is direct the incoming traffic to the two task servers. Its IP over here 34.194, it would be the end of the world if that IP ever changed for whatever reason. We have it on an elastic IP, so that shouldn't be possible. But the controllers are, every controller would have to be restarted if this IP were changed because they don't check in periodically and are married to the dot 57 IP. So anyway, that's what LB1 does","start":53.76,"end":267.52,"vid":"2025-09-15_09-01-37"},
{"subject":"Staging Green Server Functionality","text":" is it splits traffic between the two task servers. Staging green is where I hang out. This runs our full back end of taking over the tasks of both what we'll see below as the HTTP0 and the NOMQ00 servers as well as MQTT. Our current system uses MQTT for the controllers to communicate with the cloud. In recent years, we also have UDP communication from the controllers to the cloud actually on two separate UDP ports. But all of the normal traffic is still handled through MQTT. So that goes to an MQTT broker on our production system. That is a separate server. It really doesn't need to be, but Hamsa, Jamil and I got into a bit of a disagreement some years ago over just exactly why the controllers were not communicating successfully through MQTT. At that time, I split it off as a separate server to make it as simple and reliable as possible. So anyway, staging green has all of that in itself. It has an MQTT server. It has the node server handling, like I say, both HTTP0 in our production system handles more or primarily handles the responding to the front-end. So it is front-end request that it responds to. NOMQ is short for node and MQTT. The NOMQ server is much more focused on the controllers and seeing that their data is sent down and brought up and integrated correctly with the database. So staging green does that for the dev version and does everything on one machine of moderate size. It's a medium. I'm sorry, what about prod? Faisal? No. No, no, no, no. Prod0 is on a separate, or you're saying, no, for my work, all of the React stuff is handled on my local server. So there is no prod element in the staging system. I serve that locally so that it's... I do have... I run Linux rather than Windows and handling remote files is vastly easier on Linux than it is on Windows. So I could do editing on remote files with just a fraction of a second delay, but even at that it is faster to have it hosted locally. And I did want to say, you are free to interrupt me anytime you want to. This video is going to be transcribed and the transcription will be available online, but it is done in such a way that your audio path is different than mine is. So you can talk over me to ask a question anytime you want to and the transcript is still going to be clean. So please do. I don't want to have these videos become half-hour recordings of gibberish. So if something doesn't make sense to you or you want to add information, by all means do.","start":267.52,"end":524.04,"vid":"2025-09-15_09-01-37"},
{"subject":"Status of Aging Staging Green Old Server","text":" Okay, so staging green old is currently not used. Fortunately it's only a small instance. It really should be stopped so that it can be restarted sometime in the future. But I'm afraid that my housekeeping on our EC2","start":524.04,"end":546.96,"vid":"2025-09-15_09-01-37"},
{"subject":"Functionality of Mongo Server","text":" instances hasn't been all that it should be. The Mongo server, this is where our database lives. Mongo has the Mongo server. It also has our RabbitMQ server. The system is designed, and I hope that between now and the end of the year we're going to finally realize this, our server is designed as a fairly large group, 10 to 20 microservices. Each one of those microservices is currently running in such a way that it could run on its own separate server. What enables that is AMQP, the Advanced Message Queue Protocol. RabbitMQ is the server that we use physically on Mongo to handle that. So that when the USA component microservice needs to communicate to the MQTT microservice because it wants to have some more direct interaction with the controller, that message is carried over AMQP from USA to MQTT, and then the response is carried back. So those are the two big functions of our Mongo server. Mongo also has a node server running on it, running the same code that we have on everything, honestly. All of this comes from a single repo. But the code on Mongo, it detects that it's running on the Mongo server, and specifically, it's really its only task is to handle controllers that have lost their way. The MQTT server on Mongo is MQTT 00, and our production MQTT server is MQTT 03. And with an eye toward expansion, when a controller connects to the cloud for the very first time, it connects to the Mongo server, MQTT 00. And so then it is Mongo's responsibility to redirect that controller to an available MQTT server on prod. At the moment, all we have is MQTT 03. So whenever a controller... What happens from time to time is that there's some sort of a network problem on the controller end. The controller loses connection with MQTT 03, and it is programmed when that happens to go back to MQTT 00. So Mongo recognizes the new controller and redirects it back to MQTT 03. Any questions about that one? Like I said, I mean... Go ahead. That this Mongo server have a node server as well as the Mongo server. Right. And the node server is there to redirect the controllers? That's correct. Yeah. And the Mongo server have all the records, all the database. Yes. All of both the dev database and the prod database both live on Mongo. Now, again, it is our hope between now and the end of the year that we will be moving those to Mongo.com, the Atlas system. And there we will have a more easily expandable system. But I haven't had time to get around to that yet. Honestly, I'm hoping that Aris can pick up a good bit of the slack if I can just write detailed instructions. Aris is with us to take care of DevOps things, but he is currently on his wedding break. So he'll be coming back at the end","start":546.96,"end":839.84,"vid":"2025-09-15_09-01-37"},
{"subject":"Details on AWS Load Balancer and Prod Servers","text":" of the month. Okay. Oh, okay. Well, we will see. Production green A and production green B are on a AWS load balancer. It's really quite a bit of overkill. The thing is how both of them have virtually zero. Well, you can see they're running on nano instances because they have nothing to do. This handles the front end for the old cloud. And so the load balancer is there for reliability rather than load. Like I said, this is running Joomla, which runs on PHP to serve the pages for the old cloud. Prod zero, this is our main front end Prod server. Go ahead. I have one question about the production green A and green B. Right. Are they currently using by client or this is just. Oh, yeah, this is. Yeah, no. Prod zero serves. It runs react code and that's been built for production. And actually it has two servers. Both are main Prod server available at C2.Link4cloud.com. That runs there. Also our stable server. Prod S. That runs on Prod zero. But that runs in react development mode. It hasn't been built for production use. That makes it easy to update. When Fiza does her work, she uploads her changes to the Prod S server on Prod zero. And that is where we check out the code before committing it to Prod. Ubuntu 1 and Ubuntu 2 honestly are just there for my convenience. Ubuntu 1, if I have time for it, which it looks like I'm not, we're already past the 15 minute mark. Tomorrow, I'll show you the screen that I use that is completely supported by Ubuntu 1. I am on Starlink here and Starlink is a great service, but it's SSH connections break multiple times an hour. So Ubuntu 1, its primary application right now is so that I can connect to it and then through it connect to the servers so that my broken SSH connections don't bring everything down all the time. At this moment, I couldn't even tell you what Ubuntu 2 is doing, but they both run. No, I should reduce Ubuntu 2 to being nano also, I suppose. C2 demo. You know, at this moment, I couldn't tell you just exactly what C2 demo does. I'm assuming that it is a whole other front end, just like Prod 0 to support demos. But as you can see, we have rather lost interest in it and it is still running as a small instance, but it is not important in any way.","start":839.84,"end":1076.96,"vid":"2025-09-15_09-01-37"},
{"subject":"Role of Task Server Canary","text":" Task server Canary actually picks up like one one thousandth or less of the traffic on the two task servers. So our load balancer one up there at the top actually distributes basically two thirds of it to task 2x, one third of it to main task x, and a very small number of requests are handled by Canary. This is the server that I use to develop new code for the task servers, because if I bring this server down, no one is even going to notice. But here I can develop new code and verify that it works. Wayne was working with us on contract. I have to say, I personally didn't much care for the code that he, on the firmware side, I didn't much care for the code that he generated, is no longer working with us. I need to talk to Hampson Jamil about","start":1079.68,"end":1145.76,"vid":"2025-09-15_09-01-37"},
{"subject":"Role of NOMQ Server","text":" whether he would like to have the server dedicated to him. NOMQ, I talked about this before, this is the server that handles all of the MQTT requests coming in from the controllers and communicates with HTTP0 coming up down here over AMQP. MQTT3 is the separate MQTT server in the system that all the controllers directly connect to, and then this is not handled through AMQP. The NOMQ actually subscribes to the MQTT3 server","start":1145.76,"end":1196.32,"vid":"2025-09-15_09-01-37"},
{"subject":"Functionality of UDP01 Server","text":" to get all of the MQTT traffic that's coming in from the controllers. UDP01, right now, one of our production UDP servers is running on stage green, which is bad form, because the stage green can have problems just because it's a development server.","start":1196.32,"end":1222.8,"vid":"2025-09-15_09-01-37"},
{"subject":"Upcoming Changes for UDP01 Server","text":" So UDP01 will be coming soon to be a separate server that handles that UDP traffic. AI test, have you ever had anything to do with this one, Faisal? I don't think so. Yeah, I think this was for some other foray into AI from years past and has no current use. HTTP01, go ahead Faisal. Ryan also mentioned that we don't need it anymore.","start":1224.16,"end":1264.56,"vid":"2025-09-15_09-01-37"},
{"subject":"Explanation of Stopping Instances on AWS","text":" Right, yep. On AWS, you can stop an instance or you can terminate it, and if you stop an instance, it'll pick up right where it left off, so stopping these things is a fairly painless thing to do. If you terminate it, it loses its entire disk drive, so that's not an option,","start":1264.56,"end":1288.72,"vid":"2025-09-15_09-01-37"},
{"subject":"Purpose and Future of HTTP01 Server","text":" but AI tests definitely could be stopped. HTTP01, I've made several steps over the last couple of years trying to come up with a cleaner version of HTTP0, and this one remains. I haven't visited it for a few months, and probably it will become obsolete when we do the before-the-end-of-the-year server update, which will cover a lot more territory than just HTTP.","start":1288.72,"end":1320.48,"vid":"2025-09-15_09-01-37"},
{"subject":"Significance of HTTP0c Server","text":" HTTP0c is where the action is, and this handles, like I said, it is the back-end for the front-end. So, NONQ is the back-end for the controllers, HTTP0 is the back-end for the front-end.","start":1321.68,"end":1340.8,"vid":"2025-09-15_09-01-37"},
{"subject":"Insight into Linkbot Staging Server","text":" Now, linkbot staging, you must know more about that than I do, Faisal. Yes, it hosts AI and various API projects, like Faisal AI. I showed you set of chatbots, so all the fast API back-end relies there, and also we have a spreadsheet demo, it is also there. Also, there's a Godot 3D visualizer, it's also to the side-set. These three things are there, spreadsheet demo, Faisal AI linkbot, and it will be Godot 3D visualizer. Oh, okay. So, are you saying that when I go to Ryan's physical view page, am I engaging the server? No, it was the Dole 3D visualizer. Oh, okay, which he worked on. Okay, so it is not currently a part of the physical view system? Exactly. Okay, and then","start":1342.88,"end":1414.16,"vid":"2025-09-15_09-01-37"},
{"subject":"Uncertainty about Jenkins Server Role","text":" maybe I'll have to ask a reason about this, because I really don't know what role the Jenkins server, obviously this is for CICD deployment, but beyond that, I don't know what actual role the Jenkins server is playing right now. It's all being done through the Bitbucket pipeline.","start":1418.32,"end":1438.56,"vid":"2025-09-15_09-01-37"},
{"subject":"Overview of Aged Stage Blue Servers","text":" Right, okay, good. Stage Blue 2 and Stage Blue 2, if Stage Green 2 was old, Stage Blue 2 and Stage Blue are even older. Again, they're only micro-instances, so they're not costing us a lot of money, but when we do a major upgrade again, for example, using the new server architecture, we will probably use the blue-green concept, meaning that both the blue servers and the green servers are running simultaneously, and we can move controllers and customers back and forth between the two of them as necessary. The hope is that we just throw the switch, move all of our controllers and servers over to the new system, but if that fails, then we always have the blue system in the background. So this this harkens back to the last time that we made a major change","start":1438.56,"end":1506.64,"vid":"2025-09-15_09-01-37"},
{"subject":"Mystery Surrounding Stage Green 3 Server","text":" like that, which was some time ago. Stage Green 3, I don't know. It's stage zero. Yeah, the stage zero, I know that I'm getting ready for the big move to the new server, and I want to have a staging server where I can start doing some early experiments. Honestly, for the life of me, I couldn't tell you what Stage Green 3 does. So that is the whole system from a server point of view. I'm going to stop here because","start":1506.64,"end":1547.44,"vid":"2025-09-15_09-01-37"},
{"subject":"Request for AWS Access and Server Animations","text":" we've used up our half hour. So Sadaf, what other information on this subject can I give you? First, I need some animations to check these instances, because right now I don't have access of AWS. I doubt that you will have access to this unless you get into real DevOps stuff. All of these servers are available through SSH, and that's the way we communicate with them on a day-to-day level. I rarely go to this page, and I've got my finger in every server. I have just made a ticket for earnings so that he will create a user for Sadaf, so she can access it via SSH. One thing I want to ask here that you mentioned that you have a Go","start":1547.44,"end":1622.48,"vid":"2025-09-15_09-01-37"},
{"subject":"Data Maintenance on Go Server","text":" server on one of the instance. So how do you maintain the data over it? There are some things where instances get stopped or stuck. So you can act with the SSH or download the whole TV backup. We are imaging the disk daily, so we have daily disk images, and we can return to those. The database is also being backed up to just exported files daily. Let's see, the database, 95% or probably more of the quantity of the database is historical controller data, because that just accumulates second by second. There's another database that contains all of the current information from the controllers, and that is of a fair size. Beyond that, we have 50 or 100 tables of data that handle all the functionality of the front end. The historical data is backed up, like I said, daily. The current data and all of the vastly smaller tables of data to support the front end are backed up daily, not only with the disk backup, but also with the database export.","start":1623.44,"end":1735.36,"vid":"2025-09-15_09-01-37"},
{"subject":"Motivation for Transition to Atlas Database","text":" This is one of our motivations for moving over to Atlas, because with a managed solution, we will have better data backup. So, basically, you don't have any database image for the local. You are maintaining all the backup within the AWS, like saving their images or taking their backups. Correct. Before the Atlas concept came along, I wanted to spin up another database instance, so that the two of them would work together, have the same data, both be available for answering requests and with all of the database rights going to both servers. Instead, we're looking to Atlas to implement that system for us. Yeah, that would be better idea, because they provide more flexible scaling. Oh, yes.","start":1738.4,"end":1812.72,"vid":"2025-09-15_09-01-37"},
{"subject":"Challenges of Front End and Microservice Rewrites","text":" The problem with that is that to make that new system a reality, currently, the front end is being handled by the USA component. USA stands for users, sites, and accounts. That handles all of the front end traffic, and MQTT is the microservice that handles all of the controller background. Both of those need to be substantially rewritten to be able to be run in parallel, so that I can have multiple USA instances and multiple MQTT instances to make the whole system expandable, not just the database. That's going to be the time-consuming part. Like I said, really, since the system has been designed from the ground up to use the microservice concept, splitting all of the microservices onto separate servers should be fairly painless, but splitting USA and MQTT to have multiple instances of the same server, that's going to be tougher. What else? All right. Right now, nothing. Okay, are we all set? Okay, well, thank you very much, Siddhav and Faisal. I'm going to stop recording at this point.","start":1816.88,"end":1921.68,"vid":"2025-09-15_09-01-37"}]
}

export default C18SystemAtlas00;

